import { ITipoPesoAtendimento } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoPesoAtendimento/TipoPesoAtendimentoInterfaces";
import {
    AtualizarTipoPesoAtendimentoService,
    CadastrarTipoPesoAtendimentoService,
    DeletarTipoPesoAtendimentoService,
    GetTipoPesoAtendimentoService,
    ListarTipoPesoAtendimentoService,
} from "../../../../Services/Geral/GestaoDeCadastros/TipoPesoAtedimento/TipoPesoAtendimentoServices";
import { Controller } from "../../../Controller";

export function ListarTipoPesoAtendimentoController() {
    return Controller(ListarTipoPesoAtendimentoService());
}
export async function ListarTipoPesoAtendimentoAtivosController() {
    return Controller(ListarTipoPesoAtendimentoService()).then((res) =>
        res.filter((tpa) => tpa.FL_ATIVO)
    );
}
export function GetTipoPesoAtendimentoController(
    ID_TIPO_PESO_ATENDIMENTO: number
) {
    return Controller(GetTipoPesoAtendimentoService(ID_TIPO_PESO_ATENDIMENTO));
}
export function CadastrarTipoPesoAtendimentoController(
    tipoPesoAtendimento: ITipoPesoAtendimento
) {
    return Controller(CadastrarTipoPesoAtendimentoService(tipoPesoAtendimento));
}
export function AtualizarTipoPesoAtendimentoController(
    tipoPesoAtendimento: ITipoPesoAtendimento
) {
    return Controller(AtualizarTipoPesoAtendimentoService(tipoPesoAtendimento));
}
export function DeletarTipoPesoAtendimentoController(
    ID_TIPO_PESO_ATENDIMENTO: number
) {
    return Controller(
        DeletarTipoPesoAtendimentoService(ID_TIPO_PESO_ATENDIMENTO)
    );
}
